import Alpine from 'alpinejs'

/**
 * State of the consent manager
 * Takes a raw configuration object, amends it with useful data and makes the result reactive (for Alpine)
 */
export class ConsentManagerState {
  /**
   * Raw configuration (as defined in the backend)
   */
  readonly rawConfig: CM.Config.RawConfig

  /**
   * Processed, reactive configuration
   */
  readonly config: CM.Config.ProcessedConfig

  #processConfig(config: CM.Config.RawConfig): CM.Config.ProcessedConfig {
    return {
      ...config,
      groups: config.groups.map(group => ({
        ...group,
        services: group.services.map(service => ({
          ...service,
          checked: false,
        })),
      })),
    }
  }

  constructor(rawConfig: CM.Config.RawConfig) {
    this.rawConfig = rawConfig
    this.config = Alpine.reactive(this.#processConfig(rawConfig))
  }

  #services: CM.Config.ProcessedService[] | undefined

  /**
   * Reactive list of processed services
   */
  get services() {
    this.#services ??= this.config.groups.flatMap(group => group.services)
    return this.#services
  }
}
